/* CERASUS: Zahlen zählen hoch, sobald sie ins Bild scrollen (und jedes Mal neu, wenn sie wieder erscheinen) */
(function () {
  if (window.__cpdpCountup) return;
  window.__cpdpCountup = true;

  var DURATION = 1600;

  function ease(t) { return 1 - Math.pow(1 - t, 3); }

  function format(d, value) {
    var s = value.toFixed(d.dec);
    if (d.comma) s = s.replace('.', ',');
    return d.pre + s + d.suf;
  }

  function setup() {
    var els = document.querySelectorAll('[data-cpdp-count]');
    if (!els.length) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target, d = el._cpdp;
        if (!d) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5 && !d.active) {
          start(el, d);
        } else if (!entry.isIntersecting && d.active) {
          reset(el, d);
        }
      });
    }, { threshold: [0, 0.5] });

    [].forEach.call(els, function (el) {
      if (el._cpdp) return;
      var txt = el.textContent.trim();
      var m = txt.match(/^(\D*?)(\d+(?:[.,]\d+)?)(.*)$/);
      if (!m) return;
      var dec = /[.,](\d+)$/.exec(m[2]);
      var d = {
        final: txt,
        pre: m[1],
        suf: m[3],
        target: parseFloat(m[2].replace(',', '.')),
        dec: dec ? dec[1].length : 0,
        comma: m[2].indexOf(',') > -1,
        run: 0,
        active: false
      };
      el._cpdp = d;
      el.setAttribute('aria-label', txt);
      el.textContent = format(d, 0);
      observer.observe(el);
    });
  }

  function start(el, d) {
    d.active = true;
    d.run += 1;
    var token = d.run, t0 = null;
    function step(ts) {
      if (d.run !== token) return;
      if (t0 === null) t0 = ts;
      var p = Math.min((ts - t0) / DURATION, 1);
      el.textContent = format(d, d.target * ease(p));
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = d.final;
    }
    requestAnimationFrame(step);
  }

  function reset(el, d) {
    d.active = false;
    d.run += 1;
    el.textContent = format(d, 0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
